import { compose, defaultTo, reject, map, uniqBy, prop, without, adjust, assoc, findIndex, propEq } from "ramda"
import { isCriteriaEqual } from "js/state/selectors/deviceSearch/criteria"

function findCriterion(actionCriteria, stateCriterion) {
  const newCriterion = stateCriterion.search === -1 || stateCriterion.action === "CREATE"
  return actionCriteria.find(
    ({ type, search }) => type === stateCriterion.type && (newCriterion || stateCriterion.search === search),
  )
}

export default function criteria(state = [], action) {
  switch (action.type) {
    case "SET_CRITERIA":
      return uniqBy(prop("id"), [...state.filter(c => c.action !== "DELETE"), ...action.criteria])
    case "CREATE_CRITERION":
      return [...state, action.criterion]
    case "UPDATE_CRITERION":
      return state.map(c => (isCriteriaEqual(c, action.criterion) ? action.criterion : c))
    case "UPDATE_CRITERIA":
      return state.map(s => action.criteria.find(c => c.id === s.id) || s)
    case "UPDATE_NEW_CRITERIA": {
      return compose(
        reject(propEq("action", "DELETE")),
        map(stateCriterion => defaultTo(stateCriterion, findCriterion(action.criteria, stateCriterion))),
      )(state)
    }
    case "DELETE_CRITERION":
      const idx = findIndex(propEq("id", action.criterion.id), state)
      return adjust(idx, assoc("action", "DELETE"), state)
    case "REMOVE_CRITERIA":
      return without(action.criteria, state)
    case "CLEAR_UNSAVED_SEARCH_CRITERIA":
      return state.filter(c => c.id > 0 || !!c.search)
    default:
      return state
  }
}
